import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CtaButtonComponent } from '../../../../../shared/components/ui/cta-button/cta-button.component';
import type { DailyFact } from '../../services/daily-facts.service';

@Component({
  selector: 'app-daily-fact-actions',
  standalone: true,
  imports: [TranslatePipe, CtaButtonComponent],
  templateUrl: './daily-fact-actions.component.html',
  styleUrl: './daily-fact-actions.component.scss',
})
export class DailyFactActionsComponent {
  fact = input.required<DailyFact>();
  isGenerating = input<boolean>(false);
  canReview = input<boolean>(false);

  generate = output<DailyFact>();
  review = output<DailyFact>();

  onGenerate(): void {
    this.generate.emit(this.fact());
  }

  onReview(): void {
    this.review.emit(this.fact());
  }
}
